__turbopack_context__.v({
  "amount-wrapper": "styles-module__rCUa_a__amount-wrapper",
  "column-space-around-full-height": "styles-module__rCUa_a__column-space-around-full-height",
  "icon-wrapper": "styles-module__rCUa_a__icon-wrapper",
  "image-and-text-wrapper": "styles-module__rCUa_a__image-and-text-wrapper",
  "leader-board-ordered-list": "styles-module__rCUa_a__leader-board-ordered-list",
  "leaderboard-row": "styles-module__rCUa_a__leaderboard-row",
  "medal-icon-wrapper": "styles-module__rCUa_a__medal-icon-wrapper",
  "name-wrapper": "styles-module__rCUa_a__name-wrapper",
  "position-wrapper": "styles-module__rCUa_a__position-wrapper",
  "profile-image": "styles-module__rCUa_a__profile-image",
  "profile-image-wrapper": "styles-module__rCUa_a__profile-image-wrapper",
});
